import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppAppsComponent } from './apps/apps.component';

const routes: Routes = [

  { path: 'apps', component: AppAppsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
